export enum PermanentReplacementStatus {
    PENDING =  'PENDING',
    SUCCESS = 'SUCCESS',
    FAILED = 'FAILED',
    INITIATED = 'INITIATED',
    CLOSED = 'CLOSED',
}
